import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FormOutlined, EyeOutlined } from '@ant-design/icons';
import { Table, Row, Col, Breadcrumb, Typography, Tooltip } from 'antd';
import { intialPaginationState, filter, unexpectedError, showingPageTotalRange } from '../../../common_functions';

const SignaturePlacementList = props => {
  const [signaturePlacement, setSignaturePlacement] = useState([]);
  const [pagination, setPagination] = useState(intialPaginationState);
  const [sorter, setSorter] = useState(null);
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'id',
      key: 'id',
      render: (value, item, index) => {
        return (pagination.current - 1) * pagination.pageSize + index + 1;
      },
    },
    {
      title: 'Signature Read Placement',
      dataIndex: 'signature',
      key: 'signature',
      sorter: true,
      render: (text, record) => <span style={{ textTransform: 'capitalize' }}>{record.signature}</span>,
      ...filter('signature'),
    },
    {
      title: 'Actions',
      key: 'action',
      render: (text, record) => (
        <span>
          <div className="actionbtngroup">
            <Link to={'/settings/signature-placement/edit/' + record.id}>
              <Tooltip
                placement="top"
                title={props.roleType === 'admin' || props?.tabs_permissions?.settings_signature_placement?.edit ? 'Edit' : 'View'}
              >
                <button className="edit-btn">
                  {props.roleType === 'admin' || props?.tabs_permissions?.settings_signature_placement?.edit ? (
                    <FormOutlined />
                  ) : (
                    <EyeOutlined />
                  )}
                </button>
              </Tooltip>
            </Link>
            {props.deleteRecord(
              props,
              record.id,
              'signature_placement',
              'Signature placement?',
              signaturePlacement,
              setSignaturePlacement,
              props?.tabs_permissions?.settings_signature_placement?.delete
            )}
          </div>
        </span>
      ),
    },
  ];
  //Get collection data
  useEffect(() => {
    (async () => {
    await getSignaturePlacementData(pagination);
  })();
  }, []);

  const getSignaturePlacementData = async (pagination, filters = {}, sorter = '') => {
    try {
      setLoading(true);
      if (props.roleType == 'admin' || !!props.tabs_permissions.settings_signature_placement.view) {
        const response = await props.getItems('signature_placement', {
          fields: ['*,signature'],
          sort: !!sorter && sorter.field ? (sorter.order === 'ascend' ? '' : '-') + sorter.field : '-id',
          filters: filters,
          offset: pagination.pageSize * (pagination.current - 1),
          limit: pagination.pageSize,
          meta: 'filter_count',
        });
        pagination.total = response.meta.filter_count;
        setPagination(pagination);
        setSignaturePlacement(response.data);
      }
    } catch (error) {
      unexpectedError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleTableChange = async (pagination, filters, sorter) => {
    setPagination(pagination);
    setSorter(sorter);
    setLoading(true);
    let filtersitems = {};
    for (let key in filters) {
      if (filters.hasOwnProperty(key)) {
        let val = filters[key];
        if (val) {
          if (key == 'artist') {
            filtersitems['_or'] = [{ artist: { last_name: { _icontains: val[0] } } }, { artist: { First_Name: { _icontains: val[0] } } }];
          } else {
            filtersitems[key] = { _icontains: val[0] };
          }
        }
      }
    }
    await getSignaturePlacementData(pagination, filtersitems, sorter);
  };
  return (
    <Row>
      <Col span={24} className="app-breadcrumb-col">
        <Breadcrumb items={[{ title: "Settings", href: "/settings/signature-placement" }, { title: "Signature Read Placement" }]} />
      </Col>
      <Col className="white-paper" span={24}>
        <div className="dashboard">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                View Signature Read Placement
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end">
              {props.createButton(
                props.roleType,
                props.tabs_permissions.settings_signature_placement,
                `/settings/signature-placement/new`,
                'Create Signature Read Placement'
              )}
            </Col>
          </Row>
          <hr />
          <div className="artist-list">
            <Table
              scroll={{ x: 'max-content' }}
              columns={columns}
              bordered
              rowKey={record => record.id}
              dataSource={signaturePlacement}
              pagination={{ ...pagination, ...showingPageTotalRange }}
              loading={loading}
              onChange={handleTableChange}
            />
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default SignaturePlacementList;
